<template>
  <div class="offline-session-base">
    <header-base @open-dialog='disableTimer' @close-dialog='enableTimer' pageType='session'/>
    <v-alert type='warning' dismissible>Solves in this session will not be saved!</v-alert>
    <v-container>
      <v-layout>
        <v-flex xs12 md10>
          <offline-timer-base @begin-timer='disableNewData()' @stop-timer='addSolveToSession(); enableNewData()' @new-scramble='addScrambleToSession' ref='timer'/>
          <offline-session-times @open-dialog='disableTimer' @close-dialog='enableTimer' ref='sessionTimes'/>
        </v-flex>
        <v-flex md2>
            <session-tools id='tools' :scramble='$store.state.scramble'/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import HeaderBase from '@/components/HeaderBase'
import OfflineTimerBase from '@/components/OfflineTimerBase'
import OfflineSessionTimes from '@/components/OfflineSessionTimes'
import SessionTools from '@/components/SessionTools'
export default {
  name: 'offline-session-base',
  data () {
    return {}
  },
  methods: {
    addSolveToSession () {
      this.$refs.sessionTimes.addTimeToSession({
        time: {
          time: this.$store.state.time,
          plusTwo: false,
          DNF: false,
          comment: ''
        },
        solverId: this.$store.state.solverId,
        scrambleId: this.$store.state.scrambleId
      })
    },
    addScrambleToSession (data) {
      this.$refs.sessionTimes.addScrambleToSession(data)
    },
    enableTimer () {
      this.$refs.timer.timerEnabled = true
    },
    disableTimer () {
      this.$refs.timer.timerEnabled = false
    },
    // TODO: remove unneeded code that involves syncing with backend (eg. enabling and disabling new data) from all the Offline and Sample components
    enableNewData () {
      // if we enable new data then overwrite the old data and reenable sync (reenabling sync will be done asynchronously in the overwriteData function)
      this.$refs.sessionTimes.overwriteData()
    },
    disableNewData () {
      this.$refs.sessionTimes.syncData = false
    }
  },
  created () {
    this.$store.commit('setSessionId', '1')
    this.$store.commit('setSessionType', '3x3')
    if (this.$store.state.solverId === '') {
      this.$store.commit('setSolverId', '1')
      this.$store.commit('setSolver', 'You')
    }
  },
  destroyed () {
    this.$store.state.socket = null
    this.$store.commit('setScramble', '')
    this.$store.commit('setScrambleId', '')
    this.$store.commit('setSessionId', '')
    this.$store.commit('setAuthToken', '')
  },
  components: {
    OfflineSessionTimes,
    OfflineTimerBase,
    HeaderBase,
    SessionTools
  }
}
</script>
